import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextField,
  Select,
  Button,
  Grid,
  InputLabel,
  MenuItem,
  FormControl,
  Input,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { useEffect } from "react";
import { addCID, getCIDS } from "../services/cidService";
import { useDispatch, useSelector } from "react-redux";
import { setCIDS } from "../features/assessorSlice";
import { getCounties } from "../services/settingsService";
import { setCounties } from "../features/settingsSlice";

const FALLBACK_COUNTIES = [
  { code: "cha", name: "Chatham" },
  { code: "che", name: "Cherokee" },
  { code: "cla", name: "Clayton" },
  { code: "cob", name: "Cobb" },
  { code: "ful", name: "Fulton" },
  { code: "gwi", name: "Gwinnett" },
];

const CreateCID = (props) => {
  const dispatch = useDispatch();
  const storeCounties = useSelector((state) => state.settings.value.counties);
  const counties = storeCounties.length ? storeCounties : FALLBACK_COUNTIES;

  useEffect(() => {
    if (props.dialogOpen && !storeCounties.length) {
      getCounties().then((res) => {
        if (res) {
          dispatch(setCounties(res));
        }
      });
    }
  }, [props.dialogOpen, storeCounties.length, dispatch]);

  const { control, handleSubmit, register, setValue } = useForm({
    defaultValues: {
      name: "",
      mils: 0.005,
      county: "",
      notes: "",
    },
  });

  const onSubmit = async (data) => {
    data.mils = parseFloat(data.mils);
    addCID(data).then(async () => {
      props.handleClose();
      const res = await getCIDS();
      dispatch(setCIDS(res));
    });
  };

  return (
    <Dialog
      open={props.dialogOpen ? true : false}
      onClose={() => props.handleClose()}
    >
      <DialogTitle>Create CID</DialogTitle>
      <DialogContent>
        <Grid container p={1} textAlign="center" spacing={1}>
          <Grid item xs={12} mx="auto">
            <Controller
              name="county"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth>
                  <InputLabel>County</InputLabel>
                  <Select fullWidth {...field} label="County">
                    {counties.map((county) => (
                      <MenuItem key={county.code} value={county.code}>
                        {county.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <TextField {...field} label="CID Name" fullWidth />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="mils"
              control={control}
              render={({ field }) => (
                <FormControl>
                  <InputLabel>Mils</InputLabel>
                  <Input {...field} type="number" label="CID Name" fullWidth />
                </FormControl>
              )}
            />
          </Grid>

          <Grid item xs={12} mx="auto">
            <Controller
              name="notes"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  minRows={7}
                  multiline
                  fullWidth
                  label="Notes"
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          color="inherit"
          onClick={() => props.handleClose()}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          variant="contained"
        >
          Create CID
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateCID;
